import { push, ref } from 'firebase/database';
import React from 'react'
import { db } from '../../firebase';

const ActivityLog = (action, details) => {
    // Ensure action and details are provided before logging
    if (!action || !details) {
        console.error('Action and details must be provided for activity logging.');
        return;
    }

    // try {
    //     const logRef = ref(db, 'ActivityLogs');
    //     const logData = {
    //         action: action,
    //         details: details,
    //         name: localStorage.getItem("admin_name") || "Unknown",
    //         email: localStorage.getItem("admin_email") || "Unknown",
    //         // timestamp: new Date().toLocaleString(),
    //         // timestamp: Date.now(), // Current Unix timestamp in milliseconds
    //         timestamp: new Date().toISOString(), // Current ISO 8601 timestamp

    //     };
    //     push(logRef, logData)
    //         .then(() => {
    //             console.log('Activity log saved successfully.');
    //         })
    //         .catch((error) => {
    //             console.error('Error saving activity log:', error);
    //         });
    // } catch (error) {
    //     console.error('Error logging activity:', error);
    // }
}

export default ActivityLog